import { ExternalFeatureLayer } from 'features/mapping/components/layers/ExternalFeatureLayer';
import { useMapLayersState } from 'state/useMapLayersState';
import { useFilteredExternalFeatureLayers } from './useFilteredExternalFeatureLayers';

// Partial `short_name` matches for the external layers the forms carry over from the main map. Mile
// markers are the only team layers reporters keep on while creating an incident, and there is no clean
// way to identify them, since short_names can be things like: watchduty_milemarkers_0726_bba09872-milemarkers.
const FORM_SUPPORTED_SHORT_NAME_IDENTIFIERS = ['milemarkers'];

type FormExternalFeatureLayersProps = {
  shortNameIncludes?: string[];
};

/**
 * External feature layers on a form map. Visibility reads each persisted toggle directly because the form maps
 * policy disallows the TEAM_LAYER bucket that `isLayerVisible` would gate on. They are never interactive, since
 * clicking the map on a form places the incident marker.
 */
export const FormExternalFeatureLayers = (
  props: FormExternalFeatureLayersProps = {},
): JSX.Element => {
  const { shortNameIncludes = FORM_SUPPORTED_SHORT_NAME_IDENTIFIERS } = props;
  const { mapLayers } = useMapLayersState();
  const featureLayers = useFilteredExternalFeatureLayers(shortNameIncludes);

  return (
    <>
      {featureLayers.map((featureLayer) => (
        <ExternalFeatureLayer
          key={featureLayer.mapLayerId}
          visible={mapLayers.includes(featureLayer.mapLayerId)}
          interactive={false}
          sourceId={featureLayer.mapLayerId}
          featureLayer={featureLayer}
        />
      ))}
    </>
  );
};
